/* eslint-disable import/no-cycle */
import { Client } from './client';
import { CustomTabItem } from './custom-tabs';
import { Notification } from './notifications';

export interface SimpleUserDto {
  id: number;
  email_address: string;
  first_name: string;
  last_name: string;
  role: Role;
  clientsIds: number[] | null;
  firmsIds: number[] | null;
}

export interface JWTFirm {
  id: number;
  firm_name: string;
  primary: boolean;
  clients: FirmClient[];
}

export interface JWTClient {
  id: number;
  status: string;
  ms_team_id: string;
  client_name: string;
  chatbot_enabled: boolean;
}

export interface User {
  id: number;
  email_address: string;
  first_name: string;
  last_name: string;
  role: Role;
  clients?: Client[];
  firms?: JWTFirm[];
  clientIds?: number[] | null;
  hubspot_id: string | null;
  hubspot_owner_id?: string | null;
  customTabs?: CustomTabItem[];
  status: 'active' | 'disabled';
  hashedPassword?: string;
  passwordExpiresOn?: Date;
  enabled?: boolean;
  failedLoginAttemps?: number;
  enable2FA?: boolean;
  isClient?: boolean;
  authorizedClientIds?: number[];
  authorizedFirmIds?: number[];
  delegatedPermissionsActive?: boolean;
  user_request_access?: UserRequestAccess[];
  job_title?: string;
  tags?: {
    id: number;
    name: string;
    client_id?: number;
  }[];
  lastLoginAttempted?: Date | null;
  primary?: boolean;
  added_by?: string | null;
}

export interface FirmClient {
  id: number;
  client_name: string;
}

export interface UserRequestAccess {
  client_id: number;
  firm_id: number;
  client_name?: string;
  email_address?: string;
}

export interface JWTUser {
  clients: JWTClient[];
  firms: JWTFirm[];
  notifications?: Notification[];
  user_request_access: UserRequestAccess[];
  id: number;
  role: Role;
  first_name: string;
  last_name: string;
  email_address: string;
  isAdmin: boolean;
  isSpecialAdmin: boolean;
  isSuperAdmin: boolean;
  isClient: boolean;
  isInvestor: boolean;
  enabled: boolean;
  canAccessClientId: (clientId: number) => boolean;
  canAccessFirmId: (firmId: number) => boolean;
  authorizedClientIds: number[];
  authorizedFirmIds: number[];
  delegatedPermissionsActive: boolean;
  customTabs?: CustomTabItem[];
  enable2FA?: boolean;
  primary?: boolean;
  hasPassword?: boolean;
}

export type NewUser = Partial<User>;

export type ClientUser = {
  added_by: string;
  client_id: number;
  user_id: number;
  primary: boolean;
  client: Client;
  users: User;
};

export const RolesList = [
  'admin',
  'superadmin',
  'client',
  'investor',
  'specialadmin',
] as const;

export type Role = (typeof RolesList)[number];
export type UserFields =
  | 'id'
  | 'email_address'
  | 'first_name'
  | 'last_name'
  | 'role'
  | 'clients'
  | 'clientIds'
  | 'hubspot_id'
  | 'status';

// we need this form for the select component in EditUserForm component
export type ClientListOption = {
  label: string;
  value: number;
};

export type UserFormData = Omit<User, 'clients'> & {
  clients: ClientListOption[];
  clientIds?: number[];
};
